/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The game orientation enum
 * @export
 * @enum {string}
 */
export enum FxIdDomainSettingsEGameOrientation {
    Horizontal = 0,
    Vertical = 1,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdDomainSettingsEGameOrientation(value: any): boolean {
    for (const key in FxIdDomainSettingsEGameOrientation) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainSettingsEGameOrientation, key)) {
            if (FxIdDomainSettingsEGameOrientation[key as keyof typeof FxIdDomainSettingsEGameOrientation] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdDomainSettingsEGameOrientationFromJSON(json: any): FxIdDomainSettingsEGameOrientation {
    return FxIdDomainSettingsEGameOrientationFromJSONTyped(json, false);
}

export function FxIdDomainSettingsEGameOrientationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsEGameOrientation {
    return json as FxIdDomainSettingsEGameOrientation;
}

export function FxIdDomainSettingsEGameOrientationToJSON(value?: FxIdDomainSettingsEGameOrientation | null): any {
    return value as any;
}

export function FxIdDomainSettingsEGameOrientationToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdDomainSettingsEGameOrientation {
    return value as FxIdDomainSettingsEGameOrientation;
}

